import { erp } from "@/services/axios"
import Vue from "vue"

import { $mx_hasValue } from "@/mixins/util"

export const ERP = {
    namespaced: true,
    state: {
        integrations: [],
        components: [],
        selected: null,
        availability: null,
        product: null,
        loading: false
    },
    getters: {
        /**
         * Retorna as integrações cadastradas
         *
         * @param {Object} state 
         * @returns Array
         */
        getIntegrations(state) {
            return state.integrations
        },
        /**
         * Retorna a integração selecionada para o cadastro das integrações
         */
        getSelected(state) {
            return state.selected
        },
        getLoading(state) {
            return state.loading
        },
        getComponents(state) {
            return state.components
        },
        /**
         * Verifica se o componente de Disponibilidade foi contratado
         *
         * @param {Object} state 
         * @returns Boolean
         */
		getAvailabilityEnabled(state) {
			let value = false
			if (state.components && state.components.length) {
				const component = state.components.find(c => c.name === 'disponibilidade')
				if (component) value = component.active
			}

			return value
		},
        /**
         * Retorna os dados da última disponibilidade integrada/alterada
         *
         * @param {Object} state 
         * @returns {Object} Disponibilidade resultante de uma integração
         */
        getAvailability(state) {
            return state.availability
        },
        /**
         * Retorna os dados de um produto integrado cujas unidades estão sendo listadas
         *
         * @param {Object} state 
         * @returns {Object} Produto de uma integração
         */
        getProduct(state) {
            return state.product
        }
    },
    mutations: {
        SET_INTEGRATIONS(state, payload) {
            state.integrations = [...payload]
        },
        SELECT_INTEGRATION(state, payload) {
            state.selected = { ...payload }
        },
        SET_LOADING(state, payload) {
            state.loading = payload
        },
        REMOVE_INTEGRATION(state, payload) {
            const index = state.integrations.findIndex(i => i.id === payload.id)
            if (index > -1) state.integrations.splice(index, 1)
        },
        REMOVE_SELECTED(state) {
            state.selected = null
        },
        SET_COMPONENTS(state, payload) {
            state.components = [...payload]
        },
        SET_AVAILABILITY(state, payload) {
            state.availability = { ...payload }
        },
        REMOVE_AVAILABILITY(state) {
            state.availability = null
        },
        SET_PRODUCT(state, payload) {
            state.product = { ...payload }
        },
        REMOVE_PRODUCT(state) {
            state.product = null
        },
        SELECT_INTEGRATION_BY_ID(state, payload) {
            const integration = Object.values(state.integrations).find(item => item.id === parseInt(payload))
            if (integration) state.selected = { ...integration }
        }
    },
    actions: {
        /**
         * Carrega todas as integrações cadastradas no sistema
         * 
         * @returns
         */
        loadIntegrations({ commit }) {
            return erp.getAllV2('')
                .then(response => {
                    commit('SET_INTEGRATIONS', response.data.data)
                })
                .catch(error => {
                    if (error.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
                    console.log(error)
                })
        },
        /**
         * Recebe o objeto de uma integração e a remove da listagem das ingrações cadastradas
         *
         * @param {Object} payload Integração a ser removida
         */
        removeIntegration({ commit }, payload) {
            commit('REMOVE_INTEGRATION', payload)
        },
        /**
         * Recebe o objeto de uma integração e o define como a integração selecionada
         * para o cadastro de disponibilidades
         * 
         * @param {Object} payload Integração selecionada
         */
        selectIntegration({ commit }, payload) {
            commit('SELECT_INTEGRATION', payload)
        },
        /**
         * Remove a seleção de integração
         */
        removeSelected({ commit }) {
            commit('REMOVE_SELECTED')
        },
        /**
		 * Carrega todos os componentes contratados para as integrações
		 */
		loadComponents({ commit }) {
			return new Promise((resolve, reject) => {
                erp.getAllV2('configurations')
                    .then(response => {
                        const components = Object.values(response.data.data)
                            .filter(item => !!item.value_str)
                            .map(item => {
                                return {
                                    id: item.id,
                                    name: item.name,
                                    label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
                                    active: item.value_str === 'active'
                                }
                            })

                        commit('SET_COMPONENTS', components)
                        resolve()
                    })
                    .catch((error) => {
                        if (error.response?.data?.msg) {
                            Vue.prototype.$toastr.e(error.response.data.msg)
                        }
                        console.log(error)
                        reject()
                    })
            })
		},
        /**
         * Seta os dados da última integração de disponibilidade realizada/alterada
         *
         * @param {Object} payload Dados da disponbilidade integrada
         */
        setAvailability({ commit }, payload) {
            commit('SET_AVAILABILITY', payload)
        },
        /**
         * Remove os dados da última integração de disponibilidade realizada/alterada
         */
        removeAvailability({ commit }) {
            commit('REMOVE_AVAILABILITY')
        },
        /**
         * Seta os dados do produto integrado cujas unidades serão listadas
         *
         * @param {Object} payload Dados do produto selecionado
         */
        setProduct({ commit }, payload) {
            commit('SET_PRODUCT', payload)
        },
        /**
         * Remove os dados do produto integrado cujas unidades foram listadas
         */
        removeProduct({ commit }) {
            commit('REMOVE_PRODUCT')
        },
        /**
         * Recebe o ID de uma integração, carrega as integrações do sistema e seleciona
         * a integração de acordo com o ID passado
         */
        selectIntegrationById({ commit }, payload) {
            return new Promise(resolve => {
                commit('SELECT_INTEGRATION_BY_ID', payload)
                resolve()
            })
        },
        /**
         * Seta o estado do loading geral de integrações ERP
         *
         * @param {Boolean} payload Estado a ser setado no loading de integrações ERP
         */
        setLoading({ commit }, payload) {
            commit('SET_LOADING', payload)
        }
    }
}